import React, { useRef, useEffect } from "react";
import ReactECharts from "echarts-for-react";

export default function ResponsiveECharts({ option, style, ...rest }) {
  const chartRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return undefined;
    const resizeObserver = new ResizeObserver(() => {
      chartRef.current?.getEchartsInstance()?.resize();
    });
    resizeObserver.observe(el);
    return () => resizeObserver.disconnect();
  }, []);

  return (
    <div ref={containerRef} style={{ width: "100%", minWidth: 0, ...style }}>
      <ReactECharts
        ref={chartRef}
        option={option}
        style={{ height: "100%", width: "100%" }}
        notMerge
        lazyUpdate
        {...rest}
      />
    </div>
  );
}